import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const Typography = ({
  children,
  className,
  component = 'p',
  color = 'gray1',
  weight = 'normal',
  font = 'primary',
  size = 'default',
  variant = 'normal',
  align = 'left'
}) => {
  const CustomTag = `${component}`;

  return (
    <CustomTag
      className={clsx([
        'typography',
        `typography--${color}`,
        `typography--${weight}`,
        `typography--${component}`,
        `typography--${font}`,
        `typography--${size}`,
        `typography--${variant}`,
        `typography--${align}`,
        className
      ])}
    >
      {children}
    </CustomTag>
  );
};

Typography.propTypes = {
  children: PropTypes.node.isRequired,
  component: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'div']),
  color: PropTypes.oneOf(['gray1', 'gray2', 'gray3', 'gray4', 'red1', 'white', 'green', 'blue1']),
  weight: PropTypes.oneOf(['thin', 'normal', 'bold']),
  font: PropTypes.oneOf(['primary', 'secondary']),
  size: PropTypes.oneOf(['tiny', 'small', 'default', 'medium', 'large', 'big']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  variant: PropTypes.oneOf(['error', 'normal']),
  className: PropTypes.any
};

export default Typography;
